import { render, staticRenderFns } from "./ChromeExtensionPricing.vue?vue&type=template&id=4a4661ea&scoped=true&"
import script from "./ChromeExtensionPricing.vue?vue&type=script&lang=js&"
export * from "./ChromeExtensionPricing.vue?vue&type=script&lang=js&"
import style0 from "./ChromeExtensionPricing.vue?vue&type=style&index=0&id=4a4661ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4661ea",
  null
  
)

export default component.exports